import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'math_abs',
    colour: CATEGORIES.operator.color,
    tooltip: '数値の絶対値を返します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('ABS', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を絶対値にした数値 ' }],
        },
    ],
});
